import Vue from 'vue'
import VueRouter from 'vue-router'

const Home = () => import('../views/Home.vue')
const Index = () => import('../views/Index.vue')
const About = () => import('../views/About.vue')
const Member = () => import('../views/Member.vue')
const News = () => import('../views/News.vue')
const Library = () => import('../views/Library.vue')
const Branch = () => import('../views/Branch.vue')
const Contact = () => import('../views/Contact.vue')
const Details = () => import('../views/Details.vue')
const HomeEn = () => import('../views_en/HomeEn.vue')
const IndexEn = () => import('../views_en/IndexEn.vue')
const AboutEn = () => import('../views_en/AboutEn.vue')
const MemberEn = () => import('../views_en/MemberEn.vue')
const NewsEn = () => import('../views_en/NewsEn.vue')
const LibraryEn = () => import('../views_en/LibraryEn.vue')
const BranchEn = () => import('../views_en/BranchEn.vue')
const ContactEn = () => import('../views_en/ContactEn.vue')
const DetailsEn = () => import('../views_en/DetailsEn.vue')
const ConferenceHome = () => import('../conference/ConferenceHome.vue')
const ConferenceIndex = () => import('../conference/ConferenceIndex.vue')
const ConferenceList = () => import('../conference/ConferenceList.vue')
const ConferenceDetails = () => import('../conference/ConferenceDetails.vue')
import Error from '../views/Error.vue'

Vue.use(VueRouter)

const routes = [
    // 主站页面
    {
        name: 'home',
        path: '/',
        component: Home,
        redirect: '/index',
        children: [
            {
                name: 'index',
                path: '/index',
                component: Index,
                meta: { title: '国家动物健康与食品安全创新联盟' }
            },
            {
                name: 'about',
                path: '/about',
                component: About,
                meta: { title: '关于联盟' }
            },
            {
                name: 'member',
                path: '/member',
                component: Member,
                meta: { title: '会员专区' }
            },
            {
                name: 'news',
                path: '/news',
                component: News,
                meta: { title: '新闻动态' }
            },
            {
                name: 'library',
                path: '/library',
                component: Library,
                meta: { title: '联盟智库' }
            },
            {
                name: 'branch',
                path: '/branch',
                component: Branch,
                meta: { title: '分支机构' }
            },
            {
                name: 'contact',
                path: '/contact',
                component: Contact,
                meta: { title: '联系我们' }
            },
            {
                name: 'details',
                path: '/details/:name/:type/:id',
                component: Details,
                meta: { title: '文章详情' }
            }
        ]
    },
    // 主站英文页面
    {
        name: 'home_en',
        path: '/home_en',
        component: HomeEn,
        redirect: '/index_en',
        children: [
            {
                name: 'index_en',
                path: '/index_en',
                component: IndexEn,
                meta: { title: 'National animal health and Food Safety Innovation Alliance' }
            },
            {
                name: 'about_en',
                path: '/about_en',
                component: AboutEn,
                meta: { title: 'About Us' }
            },
            {
                name: 'member_en',
                path: '/member_en',
                component: MemberEn,
                meta: { title: 'Member Area' }
            },
            {
                name: 'news_en',
                path: '/news_en',
                component: NewsEn,
                meta: { title: 'News' }
            },
            {
                name: 'library_en',
                path: '/library_en',
                component: LibraryEn,
                meta: { title: 'Alliance think tank' }
            },
            {
                name: 'branch_en',
                path: '/branch_en',
                component: BranchEn,
                meta: { title: 'Affiliated Agency' }
            },
            {
                name: 'contact_en',
                path: '/contact_en',
                component: ContactEn,
                meta: { title: 'Contact Us' }
            },
            {
                name: 'details_en',
                path: '/details_en/:name/:type/:id',
                component: DetailsEn,
                meta: { title: 'Article Details' }
            }
        ]
    },
    // 大会页面
    {
        name: 'conference',
        path: '/conference',
        component: ConferenceHome,
        redirect: '/conference/index',
        children: [
            {
                name: 'confernece_index',
                path: '/conference/index',
                component: ConferenceIndex,
                meta: { title: '第六届中国动物健康与食品安全大会' }
            },
            {
                name: 'confernece_list',
                path: '/conference/list/:type/:category/',
                component: ConferenceList,
                meta: { title: '文章列表' }
            },
            {
                name: 'confernece_details',
                path: '/conference/details/:type/:category/:id',
                component: ConferenceDetails,
                meta: { title: '文章详情' }
            }
        ]
    },
    { name: 'error', path: '*', component: Error }
]

const router = new VueRouter({
    routes,
    linkActiveClass: 'router_active'
})

export default router
